import { useMemo } from 'react';
import { get } from 'lodash';

import {
  FIELD_PATHS,
  FIELD_VALUES,
  PROPERTY_USE_OPTIONS,
  PROPERTY_USE_OPTIONS_OTHER_PROPERTY_ASSET,
  PROPERTY_USE_OPTIONS_REFINANCE,
} from '@funnels/constants';

import { useFormValues } from '../useFormValues';

export function usePropertyUse(index: number) {
  const [formValues, setFormValue] = useFormValues();
  const primaryPurpose = get(formValues, FIELD_PATHS.ASSET_PRIMARY_PURPOSE(index));
  const zoneType = get(formValues, FIELD_PATHS.ASSET_PROPERTY_ZONING(index));
  const isOtherPropertyAsset = !get(formValues, FIELD_PATHS.ASSET_USED_AS_SECURITY(index));
  const isRefinance = !get(formValues, FIELD_PATHS.ASSET_TO_BE_PURCHASED(index));
  const items = useMemo(() => {
    if (isOtherPropertyAsset) {
      return PROPERTY_USE_OPTIONS_OTHER_PROPERTY_ASSET;
    } else if (isRefinance) {
      return PROPERTY_USE_OPTIONS_REFINANCE;
    }

    return PROPERTY_USE_OPTIONS;
  }, [isRefinance, isOtherPropertyAsset]);
  const value = useMemo(() => {
    if (zoneType === FIELD_VALUES.COMMERCIAL) {
      return FIELD_VALUES.COMMERCIAL;
    }

    return primaryPurpose;
  }, [primaryPurpose, zoneType]);

  function handleChange(propertyUse: string) {
    if (propertyUse === FIELD_VALUES.COMMERCIAL) {
      setFormValue(FIELD_PATHS.ASSET_PRIMARY_PURPOSE(index), FIELD_VALUES.INVESTMENT);
      setFormValue(FIELD_PATHS.ASSET_PROPERTY_ZONING(index), FIELD_VALUES.COMMERCIAL);
    } else {
      setFormValue(FIELD_PATHS.ASSET_PRIMARY_PURPOSE(index), propertyUse);
      setFormValue(FIELD_PATHS.ASSET_PROPERTY_ZONING(index), FIELD_VALUES.RESIDENTIAL);
    }
  }

  return { value, items, handleChange };
}
